import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";
import TopBar from "./TopBar";
import ProcessingQueue from "../users/ProcessingQueue";

const DEFAULT_AI_PREFERENCES = {
  tone: "Default",
  length: "Default",
  aiRole: "Default",
  userRole: "Default",
};

const MainLayout1 = () => {
  const [isSearchActive, setIsSearchActive] = useState(true);
  const [isKnowledgeSearchActive, setIsKnowledgeSearchActive] = useState(false);
  const [uploadedDocNames, setUploadedDocNames] = useState([]);
  // console.log("Uploaded files in textarea",uploadedDocNames)
  const [aiPreferences, setAiPreferences] = useState(() => {
    const stored = localStorage.getItem("aiPreferences");
    return stored ? JSON.parse(stored) : DEFAULT_AI_PREFERENCES;
  });

  const [sidebarExpanded, setSidebarExpanded] = useState(() => {
    const storedState = localStorage.getItem("sidebarExpanded");

    if (storedState !== null && window.innerWidth > 768) {
      return JSON.parse(storedState);
    }

    // Desktop open, Mobile closed
    return window.innerWidth > 768;
  });

  // Handle resize behavior
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setSidebarExpanded(false);
      } else {
        const stored = localStorage.getItem("sidebarExpanded");
        setSidebarExpanded(stored ? JSON.parse(stored) : true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    localStorage.setItem("aiPreferences", JSON.stringify(aiPreferences));
  }, [aiPreferences]);

  // Persist sidebar state on desktop only
  useEffect(() => {
    if (window.innerWidth > 768) {
      localStorage.setItem("sidebarExpanded", JSON.stringify(sidebarExpanded));
    }
  }, [sidebarExpanded]);

  const resetAiPreferences = () => {
    setAiPreferences(DEFAULT_AI_PREFERENCES);
  };

  return (
    <div className="app">
      <Sidebar
        expanded={sidebarExpanded}
        toggleSidebar={() => setSidebarExpanded(!sidebarExpanded)}
      />

      <div
        className={`main-content-wrapper ${
          sidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <nav className="topbar-wrapper">
          <TopBar
            sidebarExpanded={sidebarExpanded}
            toggleSidebar={() => setSidebarExpanded(!sidebarExpanded)}
            isSearchActive={isSearchActive}
            setIsSearchActive={setIsSearchActive}
            isKnowledgeSearchActive={isKnowledgeSearchActive}
            setIsKnowledgeSearchActive={setIsKnowledgeSearchActive}
          />
        </nav>

        <main className="page-content">
          <Outlet
            context={{
              isSearchActive,
              setIsSearchActive,
              isKnowledgeSearchActive,
              setIsKnowledgeSearchActive,
              //to send the docs names attached
              uploadedDocNames,
              setUploadedDocNames,
              aiPreferences,
              setAiPreferences,
              resetAiPreferences,
              DEFAULT_AI_PREFERENCES,
            }}
          />
        </main>
        <ProcessingQueue />
      </div>
    </div>
  );
};

export default MainLayout1;
